"use strict";

/*
 * Search widget for mainmenu
 * Работает с консолью поиска в главном меню, а также 
 * со стандартными полями поиска, кот включают в себя:
 * 1. Поле для ввода текста для поиска (name=search_text)
 * 2. кнопка по которому осуществляется поиск (name=search_btn)
 * 3. источник данных, (по умолчанию "Каталог") (name=search_source)
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var me = this;
    var options = {
      //Ссылка на иконку поиска в главном меню
      searchIcon: null,
      //Ссылка на контейнер консоли поиска в главном меню
      searchConsole: null,
      //Список всех стандартных полей поиска
      searchField: null
    };

    //Источник поиска
    this.sourceMap = [{
      name: "Каталог",
      url: "/Catalog/?template={0}&articul=true&LoadResults=true&name=true&searchBylink=true&fromLeftCol=true&catalogProductsOnly=true"
    }, {
      name: "Запросы",
      url: "/Request/Positions?activeTab=requestTab&search={0}"
    }, {
      name: "Счета/Резервы",
      url: "/Request/Positions?activeTab=billTab&search={0}"
    }, {
      name: "Грузы",
      url: "/Request/Positions?activeTab=cargoTab&search={0}"
    }];

    // Инициализация параметров
    this.initParam = function () {
      // ссылки из главного меню
      options.searchIcon = $('#search-widget');
      options.searchConsole = $('#searchConsoleWidget');

      // ссылки для всех стандартных полей поиска
      options.searchField = $('.search-field');
      $.b2b.fastSearchProduct && $.b2b.fastSearchProduct.init(5);
    };

    // Инициализация событий для консоли поиска из главного меню
    this.initMainMenuEvents = function () {
      //Клик на иконку поиска в верхнем меню
      options.searchIcon.on('click', function (e) {
        e.preventDefault();
        me.show();
      });
    };

    // Инициализация стандартных событий
    this.initDefaultEvents = function () {
      //Обработка нажатия клавиш для стандартного поля
      options.searchField.find('[name=search_text]').keyup(function (e) {
        e.preventDefault();

        //по "Enter" запустить поиск
        if (e.keyCode === 13) {
          var searchField = $(this).parents(".search-field");
          var isMainMenu = options.searchConsole[0] === searchField[0];
          me.applySearch(searchField, isMainMenu);
        }
      });

      //Установить выбранный источник данных для поиска
      options.searchField.find(".dropdown-menu li a").click(function () {
        var dataText = $(this).text();
        var dataIndex = parseInt($(this).attr("source"));
        if (dataIndex >= me.sourceMap.length) return;
        var searchField = $(this).parents(".search-field");
        searchField.find(".dropdown-selected-name").text(dataText);
        searchField.find('[name=search_source]').val(dataIndex);
      });

      //Клик на кнопку "поиск"
      options.searchField.find('[name=search_btn]').on('click', function (e) {
        e.preventDefault();
        var searchField = $(this).parents(".search-field");
        var isMainMenu = options.searchConsole[0] === searchField[0];
        me.applySearch(searchField, isMainMenu);
      });
    };
    $('#dayPromotionLink').click(function () {
      var url = "/Catalog?LoadResults=True&SearchByLink=True&MpTypes=11";
      addCatalogDefaultFilterToUrl(url);
    });
    $('#laptopsTabletsLink').click(function () {
      openCatalogGroup("173670");
    });
    $('#pcAccessoriesLink').click(function () {
      openCatalogGroup("10243");
    });
    $('#serversLink').click(function () {
      openCatalogGroup("23318");
    });
    $('#computersLink').click(function () {
      openCatalogGroup("11153");
    });
    $('#proAVLink').click(function () {
      openCatalogGroup("116316");
    });
    function openCatalogGroup(Group) {
      var template = "/Catalog?LoadResults=True&Groups={0}";
      var url = String.format(template, encodeURIComponent(Group));
      addCatalogDefaultFilterToUrl(url);
    }
    function addCatalogDefaultFilterToUrl(url) {
      $.b2b.ajax({
        url: '/Catalog/GetUserCatalogSettings',
        type: 'POST',
        success: function success(data) {
          if (data) {
            url += "&availableAtStockOnly=" + data.AvailableAtStockDefaultFilter;
            url += "&availableAtTransitOnly=" + data.AvailableAtTransitDefaultFilter;
            url += "&rusDescription=" + data.RusDescriptionDefaultFilter;
          }
          document.location.href = url;
        },
        internalError: function internalError(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);
        }
      });
    }

    // Инициализация событий
    this.initEvents = function () {
      this.initMainMenuEvents();
      this.initDefaultEvents();
    };
    this.applySearch = function (searchField, isMainMenu) {
      if (!searchField || searchField.length === 0) return;

      //Получить все данные с текущей консоли поиска
      var data = me.getData(searchField);
      //Проверка запроса
      if (!me.checkQuery(data)) return;
      //Проверка источника данных
      if (data.source !== parseInt(data.source, 10)) return;

      //Проверка источника данных
      if (data.source >= me.sourceMap.length) return;

      //Получить url для заданного источника данных
      var template = me.sourceMap[data.source].url;
      var url = String.format(template, encodeURIComponent(data.query));

      //Быстрый поиск товара, если поиск осуществлен с главного меню, есть права и выбран источник данных "Каталог"
      if (isMainMenu && data.source === 0 && $.b2b.fastSearchProduct) return this.fastSearchProduct(data.query, url);
      if (data.source === 0) {
        $.b2b.ajax({
          url: '/Catalog/GetUserCatalogSettings',
          type: 'POST',
          success: function success(data) {
            url += "&availableAtStockOnly=" + data.AvailableAtStockDefaultFilter;
            url += "&availableAtTransitOnly=" + data.AvailableAtTransitDefaultFilter;
            url += "&rusDescription=" + data.RusDescriptionDefaultFilter;
            document.location.href = url;
          },
          internalError: function internalError(jqXHR) {
            $.b2b.errors.showAjaxError(jqXHR);
          }
        });
      } else {
        //redirect
        document.location.href = url;
      }
    };

    //Быстрый поиск товара
    this.fastSearchProduct = function (query, redirectHref) {
      var receiveProductsCallback = function receiveProductsCallback(productData) {
        if (productData === undefined || productData.Products === undefined || !Array.isArray(productData.Products)) {
          return true;
        }
        if (productData.ProductsCount > 4) {
          document.location.href = redirectHref;
          return false;
        }
        return true;
      };
      $.b2b.fastSearchProduct && $.b2b.fastSearchProduct.applySearch(query, receiveProductsCallback);
    };
    this.getData = function (searchField) {
      var source = parseInt(searchField.find('[name=search_source]').val());
      var query = searchField.find('[name=search_text]').val();
      return {
        source: source,
        query: query
      };
    };
    this.show = function () {
      //Анимация открытия консоли
      options.searchConsole.show("slide", {
        direction: "left"
      }, 200, function () {
        //Установка фокуса
        options.searchConsole.find('[name=search_text]').focus();
      });
    };
    this.hide = function () {
      //Скрыть панель поиска товаров по каталогу
      $.b2b.fastSearchProduct && $.b2b.fastSearchProduct.closeWidget();

      //Анимация закрытия консоли
      options.searchConsole.hide("slide", {
        direction: "left"
      }, 200);
    };
    this.init = function () {
      me.initParam();
      me.initEvents();
    };

    //Методы для работы с поиском
    // TODO Все это очень и очень плохо. Надо бы логику клиентской проверки фразы для поиска вынести в одно место.
    this.checkQuery = function (data) {
      var query = $.trim(data.query);

      // проверка запроса осуществляется только для каталога
      if (this.sourceMap[data.source].name !== "Каталог") return true;
      if (!query) return false;
      var trimmedval = query;
      var tab = RegExp("\\t", "g");
      var preval = trimmedval.replace(tab, ' ');
      var finval = preval.replace(/\s\s+/g, ' ');
      if (finval.length > 0) {
        // если используют поиск с ковычками, то ок
        if (finval[0] === '"' && finval[finval.length - 1] === '"') {
          data.query = encodeURIComponent(trimmedval);
          return true;
        }

        // теперь разбиваем на слова и проверяем
        var inputLengthArr = finval.split(" ");
        var contrInputL = false;
        var contrCount = 0;
        for (var i = 0; i < inputLengthArr.length; i++) {
          if (contrInputL === false) {
            ++contrCount;
          } else {
            break;
          }
        }
        var totalval = finval.replace(/\s\s+/g, '');
        if (totalval.length < 50 && contrInputL === false && contrCount < 10) {
          data.query = trimmedval;
        } else {
          $.b2b.toastNotificationService.showError("Общая длина строки поиска не должна превышать 50 символов! Всего слов должно быть не более 10!");
          return false;
        }
      }
      return true;
    };
  };
  var instance = new Widget();
  $(document).ready(function () {
    instance.init();
  });
})(jQuery);